import { AgentMessage_Role, AgentMessage_Type } from "gitpod-next-api/gitpod/v1/agent_pb";
import { parseSubagentName } from "@/utils/subagent";

export function truncateName(name: string, maxLength = 50): string {
    if (name.length <= maxLength) return name;
    return name.slice(0, maxLength - 1) + "…";
}

/**
 * Resolves a display name from an agent execution name.
 * For subagents, extracts the task portion from "[subagent:<id>] <task>".
 * Falls back to the raw name or "Agent" if unavailable.
 */
export function resolveAgentDisplayName(executionName: string | undefined): string {
    if (!executionName) return "Agent";
    const parsed = parseSubagentName(executionName);
    return truncateName(parsed?.task || executionName);
}

export function getAgentMessageBadgeLabel(
    role: AgentMessage_Role,
    messageType: AgentMessage_Type,
    displayName: string,
): string {
    if (role === AgentMessage_Role.PARENT) {
        return `Ask from ${displayName}`;
    }
    // role is CHILD or UNSPECIFIED — treat as child
    if (messageType === AgentMessage_Type.COMPLETE) {
        return `${displayName} completed`;
    }
    return `Update from ${displayName}`;
}
